import { formatDate } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { ConstrainedField } from '@app/shared/models/constrained-field';
import {
  NgxMatDateAdapter,
  NgxMatNativeDateAdapter,
} from '@angular-material-components/datetime-picker';
import { CustomDateAdapter } from '@shared/utils/date-adapter';

@Component({
  selector: 'app-datepick-cell',
  templateUrl: './datepick-cell.component.html',
  styleUrls: ['./datepick-cell.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: NgxMatNativeDateAdapter, useClass: CustomDateAdapter },
    { provide: NgxMatDateAdapter, useClass: CustomDateAdapter },
  ],
})
export class DatepickCellComponent {
  @Input() public field!: ConstrainedField;

  public toDbModel(value: string | null): any {
    if (value != null) {
      switch (this.field.controlType) {
        case 'date':
          return formatDate(value, 'yyyy-MM-dd', 'en');
          break;
        case 'datetime':
          return formatDate(value, 'yyyy-MM-dd HH:mm:ss', 'en');
          break;
      }
    }
    return value;
  }

  dateFilter = (d: Date | null): boolean => {
    if (!this.field['extraData']) return true;

    const day = (d || new Date()).getDay();
    let res = this.field.extraData['allowedDays']
      ? this.field.extraData['allowedDays'].includes(day)
      : true;

    return res;
  };
}
